export default {"src":"/_next/static/media/pn.ab8c73aa.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};